module.exports = __webpack_public_path__ + "static/media/Portrait-10168.cc75b028.jpg";